import React from 'react';

import * as ST from './styled';

interface IServices {
    title: string,
    description: string,
    href: string,
    link: string,
    popupHref: string,
    img: string,
    changeUrl: (url: string) => void,
}

const Card = ({
        title,
        description,
        link,
        href,
        popupHref,
        img,
        changeUrl,
    }: IServices) => {
    return (
        <ST.Service img={img}>
            <ST.Title>{title}</ST.Title>
            <ST.Description>{description}</ST.Description>
            {href
                ? <ST.Link href={href}>{link}</ST.Link>
                : <ST.Link onClick= {() => changeUrl(popupHref)}>{link}</ST.Link>
            }
        </ST.Service>
    );
};

export default Card;
